import instance from "@/api/instance";

import clients from "@/api/clients";
import products from "@/api/products";
import trainers from "@/api/trainers";
import activecards from "@/api/activecards";
import schedule from "@/api/schedule";
import visits from "@/api/visits";
import user from "@/api/user";
import facilities from "@/api/facilities";
import groups from "@/api/groups";

export default {
  clients: clients(instance),
  products: products(instance),
  trainers: trainers(instance),
  activecards: activecards(instance),
  schedule: schedule(instance),
  visits: visits(instance),
  user: user(instance),
  facilities: facilities(instance),
  groups: groups(instance),
};
